import { router, useForm } from "@inertiajs/react"
import { useEffect } from "react"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import {
  adminAccountPath,
  adminAgentAgentChangelogEntryPath,
  adminAgentPath,
} from "@/routes"
import type { Agent, AgentChangelogEntry } from "@/types"

import AgentEntryForm from "./agent-entry-form"

interface EditAgentEntryProps {
  agent: Agent
  entry: AgentChangelogEntry | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function EditAgentEntry({
  agent,
  entry,
  open,
  onOpenChange,
}: EditAgentEntryProps) {
  const form = useForm({
    agent_changelog_entry: {
      title: "",
      body: "",
    },
  })

  useEffect(() => {
    if (entry) {
      form.setData("agent_changelog_entry", {
        title: entry.title,
        body: entry.body,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entry])

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!entry) return

    form.put(adminAgentAgentChangelogEntryPath(agent.uid, entry.uid), {
      onSuccess: () => {
        form.reset()
        onOpenChange(false)
        router.reload({ only: ["agent"] })
      },
    })
  }

  function handleCancel() {
    form.reset()
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Edit update</DialogTitle>
          <DialogDescription>
            Edit the update for{" "}
            <a
              href={adminAgentPath({ id: agent.uid })}
              className="underline"
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                e.preventDefault()
                router.visit(adminAgentPath({ id: agent.uid }))
              }}
            >
              {agent.name}
            </a>
            . This will appear on the agent page for the{" "}
            {agent.account_uid && agent.account ? (
              <a
                href={adminAccountPath({ id: agent.account_uid })}
                className="underline"
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault()
                  router.visit(adminAccountPath({ id: agent.account_uid! }))
                }}
              >
                {agent.account.name} account
              </a>
            ) : (
              "account"
            )}
            .
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit}>
          <AgentEntryForm
            form={form}
            onCancel={handleCancel}
            submitLabel="Update"
          />
        </form>
      </DialogContent>
    </Dialog>
  )
}
